<template>
	<div class="">

		<template v-if="device!='pc'">
			<div class="full flex" style="flex-direction: column;">
				<div style="flex: 1;">
					<div class="graph" style="display: none;" id="reback_graph"></div>
					<van-radio-group v-model="radio" @change="radioChange">
						<van-cell-group>
							<van-cell v-for="(item,index) in useablenodes" :key="index" :title="item.attrs.label.text"
								clickable @click="radioClick(item.id)">
								<template #right-icon>
									<van-radio :name="item.id"
										:disabled="item.id == currentFlowprogress.currentnodeid" />
								</template>
							</van-cell>
						</van-cell-group>
					</van-radio-group>
				</div>
				<div class="flex">
					<van-button type="default" style="flex: 1;" text="返回" @click="$emit('back',{type:'cancle'})"></van-button>
					<van-button type="primary" style="flex: 1;" text="确认" @click="$emit('back',{type:'confirm'})"></van-button>
				</div>

				<van-popup v-model="commentShow" :style="{ height: '90%' ,width:'90%'}" title="必要信息">
					<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
						<div class="full" style="position: relative;flex: 1;box-sizing: border-box;padding: 0 4px;">
							<!-- <van-divider>提交方式</van-divider> -->
							<van-radio-group v-model="type">
								<van-cell-group>
									<van-cell clickable title="直接提交给我" @click="type = 1">
										<template #right-icon>
											<van-radio :name="1" />
										</template>
									</van-cell>
									<van-cell clickable title="按流程提交" @click="type = 2">
										<template #right-icon>
											<van-radio :name="2" />
										</template>
									</van-cell>
								</van-cell-group>
							</van-radio-group>
							<van-field v-model="comment" rows="10" autosize label="建议" type="textarea"
								placeholder="请输入建议" />
							<!-- 							<div style="position: relative;width: 100%;height: 200px;">
								<tinymce ref="comment"></tinymce>
							</div> -->
						</div>
						<div class="flex" style="width: 100%;">
							<van-button type="default" style="flex: 1;" text="返回" @click="commentShow=false">
							</van-button>
							<van-button type="primary" style="flex: 1;" text="确认"
								@click="commentSubmit({type:'confirm'})"></van-button>
						</div>
					</div>
				</van-popup>



			</div>

		</template>
		<template v-else>
			<div class="graph" id="reback_graph"></div>
			<vxe-modal v-model="commentShow" width="600" height="500" :destroy-on-close="false" title="必要信息" show-footer
				:before-hide-method="commentSubmit">
				<template #default>
					<div style="margin-bottom: 20px;margin-top: 10px;">
						<div style="display: inline-block;margin-right: 20px;">提交方式：</div>
						<el-radio v-model="type" :label="1">直接提交给我</el-radio>
						<el-radio v-model="type" :label="2">按流程提交</el-radio>
					</div>
					<el-divider content-position="left">建议</el-divider>
					<div style="position: relative;width: 100%;height: 300px;">
						<tinymce ref="comment"></tinymce>
					</div>
				</template>
			</vxe-modal>
		</template>







	</div>

</template>
<style scoped>
	.graph {
		box-shadow: 0px 0px 6px #909399;

	}
</style>
<script>
	import tinymce from '@_system/components/tinymce.vue'
	import {
		Graph,
		Shape
	} from '@antv/x6';
	import {
		DagreLayout
	} from '@antv/layout'

	export default {
		props: {
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			},
			flowprogress: {
				type: Object,
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				type: 1,
				currentFlowprogress: null,
				predecessorFlowprogress: null,
				commentShow: false,
				graph: null,
				selectNode: null,
				comment: null,
				radio: '',
				useablenodes: [],
				device: window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			this.$nextTick(() => {
				this.graph = new Graph({
					container: document.getElementById('reback_graph'),
					width: 970,
					height: 470,

					snapline: true,
					interacting: false,
					connecting: {
						router: {
							name: 'er',
							args: {
								offset: 25,
								direction: 'H',
							},
						},
						createEdge() {
							return new Shape.Edge({
								attrs: {
									line: {
										stroke: '#A2B1C3',
										strokeWidth: 2,
									},
								},
							})
						},
					},
					background: {
						color: '#fffbe6', // 设置画布背景颜色
					},
					grid: {
						size: 10, // 网格大小 10px
						visible: true, // 渲染网格背景
					},
					selecting: {
						enabled: true,
						rubberband: true,
						showNodeSelectionBox: true,
						filter: ['rect']
					},
					mousewheel: {
						enabled: true
					},
				})
				this.graph.on('node:selected', () => {

					this.selectNode = this.graph.getSelectedCells()
				})
				this.graph.on('node:unselected', () => {
					this.selectNode = null
				})
				// this.graph.on('blank:mouseup', () => {
				// 	this.selectNode = null
				// })
				this.graph.zoom(0.1)
				//this.graph.centerContent()

				let res = this.flowprogress

				let current = res.current
				if (!current.nextstaffid) {
					this.currentFlowprogress = current
					let predecessor = res.predecessor
					this.predecessorFlowprogress = predecessor
					this.graph.fromJSON(current.template.flowtemplate)
					
					let model = {
						nodes: [],
						edges: [],
					}
					let dagreLayout = new DagreLayout({
						type: 'dagre',
						begin: [60, 40],
						rankdir: 'LR',
						align: 'UL',
						ranksep: 30,
						nodesep: 15,
						controlPoints: true,
					})
					let self = this.graph.getCellById(current.currentnodeid)
					
					let cells = this.graph.getPredecessors(self)

					if (cells.length != 0) {
						cells.unshift(self)
						cells = cells.reverse()
						console.log(cells,this.currentFlowprogress)
						cells.forEach((item) => {
							let ispredecessor = this.predecessorFlowprogress.findIndex((
								predecessornode) => {
								return item.id === predecessornode.currentnodeid
							})
				
							if (item.data.nodetype != 2 && ispredecessor !== -1) {
								let obj = {
									id: item.id,
									shape: 'circle',
									width: 80,
									height: 80,
									attrs: {
										body: {
											fill: 'rgb(160, 207, 255)', // 背景颜色
											stroke: '#000', // 边框颜色
										},
										label: {
											text: this.getstaffByNodeid(item.id,
												predecessor), // 文本
											fill: '#000000', // 文字颜色
											fontSize: 12, // 文字大小
										},
									}
								}
								if (item.id == this.currentFlowprogress.currentnodeid) {
									obj.shape = 'rect'
									obj.attrs.body.fill = 'rgb(225, 243, 216)'
								}
								model.nodes.push(obj)
							}
						})

						for (let i = 0; i < model.nodes.length - 1; i++) {
							model.edges.push({
								source: model.nodes[i].id,
								target: model.nodes[i + 1].id,
							})
						}


						if (this.device != 'pc') {
							this.useablenodes = model.nodes
							console.log(this.useablenodes)
						} else {
							this.graph.clearCells()
							let newModel = dagreLayout.layout(model)
							this.graph.fromJSON(newModel)
						}

					} else {
						this.error = true
						this.$confirm('发起人无法退回', '退回错误', {
							status: 'error',
						}).then(() => {
							this.$emit('error')
						})
						this.graph.clearCells()
					}
				} else {
					this.error = true
					this.$confirm('下一节点处理人已确定，无法再次退回', '退回错误', {
						status: 'error',
					}).then(() => {
						this.$emit('error')
					})

				}



			})
		},
		watch: {

		},
		computed: {

		},
		methods: {
			getstaffByNodeid(id, nodes) {
				let staffid = 0
				nodes.forEach((item) => {
					//console.log(id, item.currentnodeid)
					if (item.currentnodeid == id) {
						staffid = item.currentstaffid
					}
				})
				return window.systemMethods.getstaff(staffid)
			},
			commentSubmit(e) {
				if (e.type == 'confirm') {
					let value = this.device != 'pc' ? this.comment : this.$refs.comment.myValue
					if (value) {
						this.comment = value
						this.commentShow = false
					} else {
						this.$message.error('请填写建议')
						return new Error()
					}
				}


			},
			radioChange(e) {
				let node = this.useablenodes.find((item) => {
					return item.id == e
				})
				if (node) {
					this.selectNode = [node]
				}
			},
			radioClick(e) {
				//console.log(e)
				if (e != this.currentFlowprogress.currentnodeid) {
					this.radio = e
				}

			},
			submit() {
				if (!this.selectNode) {
					this.$message.error('请选择节点')
					return false
				} else if (this.currentFlowprogress.currentnodeid == this.selectNode[0].id) {
					this.$message.error('不能选择自己')
					return false
				} else if (!this.comment) {
					this.commentShow = true
					return false
				} else {
					//console.log(this.predecessorFlowprogress)
					let rebackflowprogressid = null
					this.predecessorFlowprogress.forEach((item) => {
						if (item.currentnodeid == this.selectNode[0].id) {
							rebackflowprogressid = item.id
						}
					})
					return {
						comment: this.comment,
						fromstaffid: this.$store.state.system.user.id,
						fromstaffname: this.$store.state.system.user.name,
						type: this.type,
						rebackflowprogressid: rebackflowprogressid
					}


				}

			}
		},
		components: {
			tinymce
		}
	}
</script>
